<template>
    <div>
        <div class="input-group">
            <span class="input-group-prepend">
                <span class="btn btn-primary btn-file">
                    {{ fileName ? 'Zmień' : 'Wybierz' }} <input type="file" accept="text/csv" @change="readFileAndGetContent" ref="fileInput">
                </span>
            </span>
            <input type="text" class="form-control" :placeholder="'Nie wybrano pliku'" :value="fileName" readonly />
            <span class="input-group-append" v-if="fileName">
                 <button class="btn btn-warning btn-reset" type="button" @click="resetFileInput">Resetuj</button>
            </span>
        </div>

        <div class="my-2" v-if="fileContent">Liczba rozpoznanych wierszy: {{ fileContent.length }}</div>

        <a href="javascript:void(0);" class="btn btn-success" v-if="fileContent && fileContent.length > 0" @click="loadData">Wczytaj dane</a>

        <div class="text-success mt-2" v-if="success">Dane zostały wczytane pomyślnie</div>

    </div>
</template>

<script>
    export default {
        name: 'QuizImportCsvComponent',
        props: ['columnsCount'],
        data() {
            return {
                file: null,
                fileName: null,
                fileContent: null,
                success: false
            }
        },
        methods: {
            readFileAndGetContent(ev) {
                const file = ev.target.files[0];
                const reader = new FileReader();

                if (file) {
                    this.fileName = file.name;
                    reader.onload = (e) => {
                        this.fileContent = [];
                        let lines = e.target.result.split("\n");
                        lines.forEach((line) => {
                            let lineData = line.split("\t");
                            if (lineData.length === this.columnsCount) {
                                this.fileContent.push(lineData);
                            }
                        });
                    };
                    reader.readAsText(file);
                }
            },
            resetFileInput() {
                this.$refs.fileInput.value = '';
                this.fileName = null;
                this.fileContent = null;
                this.success = false;
            },
            loadData() {
                this.$emit('load', this.fileContent);
                this.success = true;
            }
        }
    }
</script>

<style scoped>

    .btn-file {
        position: relative;
        overflow: hidden;
    }

    .btn-file input[type=file] {
        position: absolute;
        top: 0;
        right: 0;
        min-width: 100%;
        min-height: 100%;
        font-size: 100px;
        text-align: right;
        filter: alpha(opacity=0);
        opacity: 0;
        outline: none;
        cursor: inherit;
        display: block;
    }

</style>
